import {Injectable} from '@angular/core';
import {BaseModelService} from '../../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class ProductPurchasesReportModelService extends BaseModelService {
  tableName = 'yu_v3_product_purchases_report';
}
